import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import { onAuthStateChanged } from 'firebase/auth'
import { projectAuth } from './firebase/config'
import './assets/main.css'

let app

onAuthStateChanged(projectAuth, () => {
    if (!app) {
        app = createApp(App)
        .use(router)
        .mount('#app')
    }
})
